import React from "react";

import styled from "@emotion/styled";

import { MEDIA_QUERIES } from "shared/config/constants";

import { combineComponents } from "shared/utils/combine-components";

import { AppListProps } from "./app-list";
import { AppListV2 } from "./AppListV2/AppListV2";
import {
  ApproveDealModalProvider,
  MoreInfoDealModalProvider,
  CancelDealModalProvider,
  DeclineDealModalProvider,
} from "./modals";
import { FraudIndicatorsModalProvider } from "./modals/fraud-indicators-modal";
import { ResendToPmsModalProvider } from "./modals/resend-to-pms-modal";
import { SendToEntradaModalProvider } from "./modals/send-to-entrada-modal";

export type AppSummaryProps = AppListProps & {
  company: any;
};

const Container = styled.div`
  padding: 25px;
  ${MEDIA_QUERIES.w.ltSm} {
    padding: 8px;
  }
`;

const providers = [
  FraudIndicatorsModalProvider,
  ApproveDealModalProvider,
  MoreInfoDealModalProvider,
  CancelDealModalProvider,
  DeclineDealModalProvider,
  SendToEntradaModalProvider,
  ResendToPmsModalProvider,
];

const Providers = combineComponents(...providers);

export const AppSummary: React.FC<AppSummaryProps> = ({ dealId, company }) => {
  return (
    <Container>
      <Providers>
        <AppListV2 dealId={dealId} company={company} />
      </Providers>
    </Container>
  );
};
